import { defineStore } from 'pinia'

export const useAddToCartToastStore = defineStore('addToCartToastStore', () => {
  const show = ref(false)
  type ToastType = "success" | "error" | "info" | "warning";
  const type = ref<ToastType>('success')
  const message = ref('')
  let timeout: ReturnType<typeof setTimeout> | null = null



  function open(newType: ToastType, newMessage: string) {
    type.value = newType
    message.value = newMessage
    show.value = true

    if (timeout) clearTimeout(timeout)
    timeout = setTimeout(() => {
      show.value = false
    }, 3000)
  }

  function close() {
    show.value = false
    if (timeout) {
      clearTimeout(timeout)
      timeout = null
    }
  }

  

  return {
   show,
    type,
    message,
    // Methods
    open,
    close
  };
});


